document.addEventListener( 'DOMContentLoaded', function () {

	if ( ! document.querySelectorAll ) {
		return;
	}

	const navButtons = document.querySelectorAll( '#site-navigation > button.menu-toggle' );

	const resizeObserver = new ResizeObserver( ( entries ) => {
		for ( const entry of entries ) {
			const expanded = entry.borderBoxSize[0].inlineSize > 0;
			const menu = document.querySelector( '#' + entry.target.getAttribute( 'aria-controls' ) );
			menu.hidden = expanded;
			entry.target.setAttribute( 'aria-expanded', ! expanded );
		}
	} );

	navButtons.forEach( function( button ) {
		resizeObserver.observe( button );
	} );

	var expandButtons = document.querySelectorAll( 'button[aria-expanded][aria-controls]' );
	expandButtons.forEach( function( button ) {
		var buttonStyle = getComputedStyle( button );
		var panel = document.getElementById( button.getAttribute('aria-controls') );
		if ( ! panel ) {
			return;
		}

		if ( buttonStyle.display !== 'none' ) {
			var expanded = ( button.getAttribute( 'aria-expanded' ) === 'true' );
			panel.hidden = ! expanded;
		}

		button.onclick = function() {
			var state = this.getAttribute( 'aria-expanded' ) === 'false' ? true : false;
			this.setAttribute( 'aria-expanded', state );
			panel.hidden = ! state;
		};
	});

	var subscribe_option = document.getElementById( 'cmd-subscription' ),
			donation_option = document.getElementById( 'cmd-donation' ),
			donation_form = document.getElementById( 'donation-form-paypal' );

	if ( subscribe_option && donation_option && donation_form ) {

		var input_bn = donation_form.querySelector( 'input[name="bn"]' ),
				input_a3 = donation_form.querySelector( 'input[name="a3"]' ),
				input_t3 = donation_form.querySelector( 'input[name="t3"]' ),
				input_src = donation_form.querySelector( 'input[name="src"]' ),
				inputs_p3 = donation_form.querySelectorAll( 'input[name="p3"]' );

		subscribe_option.onchange = function( e ) {

			if ( ! this.checked ) {
				return;
			}

			input_bn.value = 'KakSePishe_Subscribe_WPS_BG';

			input_a3.disabled = false;
			input_t3.disabled = false;
			input_src.disabled = false;

			inputs_p3.forEach( function( radio ) {
				radio.disabled = false;
			} );
		};

		donation_option.onchange = function( e ) {

			if ( ! this.checked ) {
				return;
			}

			input_bn.value = 'KakSePishe_Donate_WPS_BG';

			input_a3.disabled = true;
			input_t3.disabled = true;
			input_src.disabled = true;

			inputs_p3.forEach( function( radio ) {
				radio.disabled = true;
			});
		};

		donation_option.onchange();

		donation_form.onsubmit = function( e ) {
			input_a3.value = donation_form.querySelector( 'input#amount' ).value;
		}
	}
});
